import { Grid, Box, Container } from "@mui/material";
import { SliderComunicado } from "./SliderComunicado";
import { AgendaComunicado } from "./AgendaComunicado";

export const ContenidoComunicadoIndex = () => {
    return(
        <Box sx={{mt:10}}>
            <Container maxWidth='xl'>
                <Grid container>
                    <Grid size={{xs:12, sm:12, md:6, lg:8}}>

                        <SliderComunicado/>
                    </Grid>
                      <Grid size={{xs:12, sm:12, md:6, lg:4}}>
                        <AgendaComunicado/>
                      </Grid>
                </Grid>
            </Container>

        </Box>
    )
}